const COLOR_PAIRS_POOL = [
  ['#d3d9d5', '#67796e'],
  ['#dffbe8', '#1ac95b'],
  ['#e5eeff', '#4c86f9'],
  ['#f3e6ff', '#9115fe'],
  ['#fffbf3', '#fac64b'],
  ['#fee1e0', '#fa4c4d'],
  ['#fed2e2', '#ea0359'],
  ['#fef4ec', '#f58530'],
];
function getColorFromString(str) {
  const charSum = str.split('').reduce((acc, current) => {
    return acc + current.charCodeAt(0);
  }, 0);
  const colorIndex = charSum % COLOR_PAIRS_POOL.length;
  return COLOR_PAIRS_POOL[colorIndex];
}
function getRandomColor() {
  const colorIndex = Math.floor(Math.random() * COLOR_PAIRS_POOL.length);
  return COLOR_PAIRS_POOL[colorIndex];
}

export { getRandomColor as a, getColorFromString as g };
